import { AxiosResponse } from 'axios';
import api from './Api'


export const updateSocialProfile = (sub: string, socialAccessToken: string): Promise<AxiosResponse<boolean, any>> => {
    return api.put(`/social-profile/sub`, { sub, socialAccessToken });
}